import React, { useEffect } from "react";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Icon from "./Icon";
import Status from "../types/enum/Status";
import theme from "../styles/theme";
import Button from "./Button";
interface State {
  searchTerm: string;
}
type SearchBoxProps = {
  setValues: any;
  values: State;
  handleChange: any;
  label: string;
  defaultKeyword?: string;
  hideButton?: boolean;
  onSearch: (x: string) => void;
  isFullWidth?: boolean;
  placeholder?: string;
};
function NoButtonSearch({
  setValues,
  values,
  handleChange,
  label,
  defaultKeyword,
  hideButton,
  placeholder,
  isFullWidth,
  onSearch,
}: SearchBoxProps): JSX.Element {
  useEffect(() => {
    if (defaultKeyword) {
      setValues({ ...values, searchTerm: defaultKeyword });
    }
  }, [defaultKeyword]);
  return (
    <>
      <FormControl
        size="small"
        sx={{
          mr: 1,
          width: isFullWidth ? "100%" : "350px",
          background: "white",
          // boxShadow: theme.shadow(2, Status.default),
        }}
        variant="outlined"
      >
        <InputLabel htmlFor="component-outlined">{label}</InputLabel>
        <OutlinedInput
          id="component-outlined"
          placeholder={placeholder}
          value={values.searchTerm}
          onChange={handleChange("searchTerm")}
          endAdornment={
            <InputAdornment position="end">
              <Icon name={"search"}></Icon>
            </InputAdornment>
          }
          label={label}
        />
      </FormControl>
      {!hideButton && (
        <Button
          disabled={values.searchTerm === ""}
          onClick={() => {
            onSearch(values.searchTerm);
          }}
        >
          Search
        </Button>
      )}
    </>
  );
}
export default NoButtonSearch;
